/**
 * @file     ownsProperty.ts
 * @readme   ./CLAUDE.md
 * @purpose  Shared labels for the sell-house “do you own this property”
 *           answer so the flow, CRM note, tags, and admin readout stay aligned.
 */

export const OWNS_PROPERTY_YES = 'yes';
export const OWNS_PROPERTY_NO = 'no';

export type OwnsPropertyValue = typeof OWNS_PROPERTY_YES | typeof OWNS_PROPERTY_NO;

export function isOwnsPropertyValue(value: unknown): value is OwnsPropertyValue {
  return value === OWNS_PROPERTY_YES || value === OWNS_PROPERTY_NO;
}

/** Short Yes/No for notes and the admin submission card. */
export function ownsPropertyLabel(value?: string | null): string | null {
  if (value === OWNS_PROPERTY_YES) return 'Yes';
  if (value === OWNS_PROPERTY_NO) return 'No';
  return null;
}

/** CRM tag. Distinct from occupancy (owner-occupied vs tenanted). */
export function ownsPropertyTag(value?: string | null): string | null {
  if (value === OWNS_PROPERTY_YES) return 'Owns property';
  if (value === OWNS_PROPERTY_NO) return 'Does not own property';
  return null;
}

export function ownsPropertyNoteLine(value?: string | null): string | null {
  const label = ownsPropertyLabel(value);
  return label ? `Owns this property: ${label}` : null;
}
